<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  //font-family: "Microsoft YaHei", sans-serif !important;
}
@import url('./assets/css/icon.css');

.ivu-back-top-inner{
  background-color: rgba(242, 135, 27, 0.75) !important;
}

@media screen and (max-width: 768px)
{
  .ivu-back-top-inner i{
    font-size: 9.25vw !important;
  }
}

//* {
//  font-family: "Microsoft YaHei", sans-serif !important;
//  /*
//    "Microsoft YaHei" 是微软雅黑字体，不同系统可能名称有差异，
//    sans-serif 是后备字体，当微软雅黑不可用时，用系统 sans-serif 字体替代
//    !important 用于强制覆盖其他可能设置的字体样式，确保生效
//  */
//}
.english-layout{
  font-size: 2rem !important;
  @media screen and (max-width: 768px) {
    font-size: 1.6rem !important;
  }
}
</style>
